module.exports = __webpack_public_path__ + "img/instant-callback.32f6d690.webp";